import { Form, Input } from "decorator-form";

import { BlockStylesConfig, blockStylesInput } from "../common/BlockStylesConfig";
import InputType from "common/form/InputType";

@Form({title: "Text Input Config"})
export class TextInputViewConfig {

	@Input({type: InputType.UNIT, title: "Font Size"})
	public fontSize?: string;

	@Input({type: blockStylesInput, title: "Default State"})
	public defaultState?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Focused State"})
	public focusState?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Disabled State"})
	public disabledState?: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Error State"})
	public errorState?: BlockStylesConfig;

}

/*
@Form({title: "TextInputConfig"})
export default class TextInputConfig {

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding: string = "0px 0px 0px 0px";

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color: string;

	@Input({type: InputType.UNIT, title: "Font size"})
	public fontSize: string = "14px";

	@Input({type: InputType.TEXT, title: "Icon"})
	public icon: string;

	@Input({type: InputType.NUMBER, title: "Icon Size"})
	public iconSize: number;

	@Input({type: InputType.BORDER, title: "Border"})
	public border: string = "1px solid rgba(0, 0, 0, 0)";

	@Input({type: InputType.UNIT, title: "Border radius"})
	public borderRadius: string = "3px";

	@Input({type: InputType.CHECKBOX, title: "Full Width"})
	public fullWidth: boolean;

}
*/



// WEBPACK FOOTER //
// ./src/common/views/textInput/TextInputViewConfig.ts